module.exports = __webpack_public_path__ + "img/right-img.76ed730a.png";